"use client";

import { useGamePageData } from "@casino/ui/Games/hooks";
import type { FC } from "react";
import LiveRtpColumn from "./LiveRtpColumn";

type Props = { game: SingleGameFragment; isLiveRtpEnabled?: boolean };

const LiveRtpStrip: FC<Props> = ({ game, isLiveRtpEnabled }) => {
  const { t } = useGamePageData();

  if (!isLiveRtpEnabled) return null;

  const { rtp, rtpLivePastDay, rtpLivePastSevenDays, rtpLivePastThirtyDays } =
    game;

  if (!rtp) return null;
  if (!rtpLivePastDay && !rtpLivePastSevenDays && !rtpLivePastThirtyDays) {
    return null;
  }

  return (
    <div
      data-testid="live-rtp-strip"
      className="mb-2 flex items-center justify-between gap-x-2 rounded-xl bg-background px-3 py-2"
    >
      <LiveRtpColumn
        label={t("game.stats.livertp.day", "24h")}
        rtp={rtp}
        rtpLive={rtpLivePastDay}
      />
      <LiveRtpColumn
        label={t("game.stats.livertp.week", "wk")}
        rtp={rtp}
        rtpLive={rtpLivePastSevenDays}
      />
      <LiveRtpColumn
        label={t("game.stats.livertp.month", "mo")}
        rtp={rtp}
        rtpLive={rtpLivePastThirtyDays}
      />
    </div>
  );
};

export default LiveRtpStrip;
